<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin blueBg">
        <div class="inner">

            <h3>{{ $t('menu.contact') }}</h3>

            <div class="textBox">

                <form @submit.prevent="handleOnSubmit">
                    <div class="form-group row">
                        <label for="selection" class="col-sm-4 col-form-label">{{ $t('contact.edit.selection') }}</label>
                        <div class="col-sm-8">
                            <select v-model="formData.selection" id="selection" name="selection" class="form-control" v-bind:class="{ 'is-invalid': errors.selection}">
                                <option v-for="option in $t('contact.edit.selections')" v-bind:value="option">{{ option }}</option>
                            </select>
                            <div v-if="errors.selection" class="invalid-feedback">{{ $t('errors.' + errors.selection) }}</div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="subject" class="col-sm-4 col-form-label">{{ $t('contact.edit.subject') }}</label>
                        <div class="col-sm-8">
                            <input v-model="formData.subject" type="text" id="subject" name="subject"
                                class="form-control"
                                v-bind:class="{ 'is-invalid': errors.subject}"/>
                            <div v-if="errors.subject" class="invalid-feedback">{{ $t('errors.' + errors.subject) }}</div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="content" class="col-sm-4 col-form-label">{{ $t('contact.edit.content') }}</label>
                        <div class="col-sm-8">
			                <textarea v-model="formData.content" id="content" name="content"
                                class="form-control"
                                v-bind:class="{ 'is-invalid': errors.content}"/>
                            <div v-if="errors.content" class="invalid-feedback">{{ $t('errors.' + errors.content) }}</div>
                        </div>
                    </div>

                    <div class="text-center">
                        <div class="pb-4 pr-1">
                            <button type="submit" class="btn btn-primary mr-2">
                                {{ $t('contact.edit.send') }}
                            </button>

                            <button type="button" class="btn btn-outline-primary ml-2" @click="handleOnFormClear()">
                                {{ $t('contact.edit.clear') }}
                            </button>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>


<script>
    import contactService from '../../services/ContactService';

    export default {
        name: 'contact-module',

        components: {
        },

        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
            }
        },

        created() {
            this.formData.selection = localStorage.getItem('selection')
            this.formData.subject = localStorage.getItem('subject')
            this.formData.content = localStorage.getItem('content')

            localStorage.removeItem('selection')
            localStorage.removeItem('subject')
            localStorage.removeItem('content')
        },

        methods: {
            getDefaultFields() {
                return {
                    selection: '',
                    subject: '',
                    content: '',
                };
            },

            handleOnFormClear() {
                this.formData = this.getDefaultFields();
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();

                try {
                    const result = await contactService.confirm({
                        ...this.formData
                    });

                    localStorage.setItem('selection', this.formData.selection)
                    localStorage.setItem('subject', this.formData.subject)
                    localStorage.setItem('content', this.formData.content)

                    this.$router.push('/contact/confirm');
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .btn-primary {
        width: 70px;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }
    .btn-outline-primary {
        width: 70px;
    }
</style>
